/** Los filtros multivalor van como parámetro repetido (?x=1&x=2), que es lo que espera Spring. */
export function serializeRepeatedParams(p: object): string {
    const searchParams = new URLSearchParams();
    Object.entries(p).forEach(([key, value]: [string, unknown]) => {
        if (value == null) return;
        if (Array.isArray(value)) {
            value.forEach((v) => searchParams.append(key, String(v)));
        } else {
            searchParams.append(key, String(value));
        }
    });
    return searchParams.toString();
}
